import state from './state';
import * as getters from './getters';
import * as mutations from './mutations';
import * as actions from './actions';
// Initializing and exporting the vuex store with state, getters, mutations and actions
export default {
    state,
    getters,
    mutations,
    actions,
};
